import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { site } from "@/content/site";
import { Logo } from "@/components/Logo";

export default function Footer() {
  const live = site.socials.filter((s) => s.url);
  return (
    <footer data-testid="site-footer" className="pointer-events-none relative z-10 mt-24">
      <div className="flex flex-col items-start gap-6 sm:flex-row sm:items-end sm:justify-between">
        <div className="float-chip chip-bottom-left pointer-events-auto max-w-[85vw] px-6 pb-7 pt-6 sm:max-w-md sm:px-8">
          <Link to="/" aria-label="EVE — home" data-testid="footer-logo-link">
            <Logo />
          </Link>
          <p className="mt-4 text-sm leading-relaxed text-eve-silver">
            Modern rock from {site.band.origin}. The ultimate rock party experience.
          </p>
          <p className="mt-3 font-mono text-[10px] uppercase tracking-[0.3em] text-white/30">
            {site.band.community} — the official fan community
          </p>
          <p
            data-testid="footer-copyright"
            className="mt-5 font-mono text-[10px] uppercase tracking-[0.3em] text-white/30"
          >
            Copyright © EVE. All rights reserved.
          </p>
        </div>

        <div className="float-chip chip-bottom-right pointer-events-auto self-end px-6 pb-7 pt-6 sm:self-auto sm:px-8 sm:text-right">
          <span className="font-mono text-[10px] uppercase tracking-[0.3em] text-white/30">
            Follow
          </span>
          {live.length > 0 ? (
            <ul className="mt-3 flex flex-wrap gap-x-5 gap-y-2 sm:justify-end">
              {live.map((s) => (
                <li key={s.name}>
                  <a
                    data-testid={`footer-social-${s.name.toLowerCase().replace(/\s+/g, "-")}`}
                    href={s.url as string}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center gap-1.5 font-mono text-[11px] uppercase tracking-[0.25em] text-eve-silver transition-colors duration-300 hover:text-eve-cyan"
                  >
                    {s.name} <ArrowUpRight size={12} />
                  </a>
                </li>
              ))}
            </ul>
          ) : (
            <p className="mt-3 font-mono text-[11px] uppercase tracking-[0.25em] text-white/25">
              Official channels coming soon
            </p>
          )}
          <div className="mt-3 sm:flex sm:justify-end">
            <a
              href={site.links.universe}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-universe-link"
              className="inline-flex items-center gap-1.5 font-mono text-[11px] uppercase tracking-[0.25em] text-eve-magenta transition-colors duration-300 hover:text-eve-ink"
            >
              Join {site.band.community} Universe <ArrowUpRight size={12} />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
